import { CheckCircle, XCircle } from "lucide-react";
import { useCallback } from "react";


export interface TogglerProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
  ariaLabel?: string;
}

// Toggler Component
const Toggler: React.FC<TogglerProps> = ({
    checked,
    onChange,
    label,
    disabled = false,
    className = '',
    ariaLabel = 'Toggle switch',
  }) => {
    const handleToggle = useCallback(() => {
      if (!disabled) {
        onChange(!checked);
      }
    }, [checked, onChange, disabled]);
  
    return (
      <div className={`flex items-center space-x-2 ${className}`}>
        {label && (
          <label
            className={`text-sm font-medium text-gray-700 ${disabled ? 'opacity-50' : ''}`}
            htmlFor="toggler"
          >
            {label}
          </label>
        )}
        <button
          type="button"
          id="toggler"
          onClick={handleToggle}
          disabled={disabled}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
            checked ? 'bg-blue-600' : 'bg-gray-200'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
          aria-checked={checked}
          aria-label={ariaLabel}
          role="switch"
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200 ease-in-out ${
              checked ? 'translate-x-6' : 'translate-x-1'
            }`}
          >
            {checked ? (
              <CheckCircle
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-blue-600"
                size={12}
                aria-hidden="true"
              />
            ) : (
              <XCircle
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-gray-400"
                size={12}
                aria-hidden="true"
              />
            )}
          </span>
        </button>
      </div>
    );
  };

  export default Toggler;